import CollapsableComponent from '@components/CollapsableComponent';
import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import Page from '@components/Page';
import SelectableUnitUserComponent from '@components/SelectableUnitUserComponent';
import Table, { ITableColumn } from '@components/TableComponent';
import UserRadioSelect from '@components/userRadioSelectComponent';
import NotificationComponent from '@helpers/_showNotifications';
import { Assignment as AssignmentInterface } from '@interfaces/ehss/Assignment';
import { IField } from '@interfaces/global/config-global';
import IPagination from '@interfaces/IPagination';
import { IUser as UserInterface, IUser } from '@interfaces/IUser';
import IUserExtraFieldsState from '@interfaces/IUserExtraFieldsState';
import AppContext from '@services/Context';
import AuditService from '@services/ehss/Audit';
import ConfigService from '@services/global/Config';
import ManagerService from '@services/ManagerService';
import UserService from '@services/UserService';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Checkbox, Col, Modal, Row } from 'antd';
import React from 'react';

interface IManagerContainerPropType { history: { replace: Function }; match: any; }

interface IManagerContainerStateType extends IUserExtraFieldsState {
  curOffset?: string;
  curUsersOffset?: string,
  filteredTableData: AssignmentInterface[];
  haveItemSelected: boolean;
  iconLoading?: boolean;
  isLoading: boolean;
  loadingMoreManagers: boolean;
  loadingMoreUsers: boolean;
  loadingUsersBySearch: boolean;
  noAudited?: boolean;
  noUserFound: boolean,
  savingItem: boolean;
  searchManager: string;
  searchUser: string;
  selectedManager: string,
  serverResponse: any;
  showFormModal: boolean;
  statusWanted?: number;
  tableData: AssignmentInterface[];
  totalShowData?: number;
  usersAmount: number;
  usersData: UserInterface[];
  userSelectedAsUser: string;
  isCollapsed: boolean;
  registerModalTableColumns: ITableColumn[];

  showUserSelectModal: boolean;
  selectedIDRole: string,

  searchAvailableUsers: string;
  searchSavedUsers: string;

  loadingAvailableUsers: boolean;
  loadingSavedUsers: boolean;

  availableUsersData: IUser[];
  savedUsersData: any[];
  availableUsersAmount: number;
  savedUsersAmount: number;
  loadingMoreAvailableUsers: boolean;
  loadingMoreSavedUsers: boolean;
  availableUsersCurOffset?: string;
  savedUsersCurOffset?: string;
};

const CheckboxGroup = Checkbox.Group;

//FIXME: this is gonna be a problem
const radioComponentTableColumnSize = 200;
const tableColumns = [
  {
    title: 'table.users.name',
    dataIndex: 'name',
    key: 'name',
    width: '30%',
  },
  {
    title: 'table.auditors.registration',
    dataIndex: 'username',
    key: 'username',
  },
  {
    title: 'table.manager.user',
    dataIndex: 'audits',
    key: 'audits',
  },
  {
    title: 'table.actions',
    dataIndex: 'action',
    key: 'action',
    width: '10%',
  }
];

const usersAvailableTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];

const usersSavedTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  },
];

export default class ManagerContainer extends React.Component<IManagerContainerPropType, IManagerContainerStateType> {

  private activeUnitId?: string;
  private locale?: string;
  private _managerService: ManagerService;
  private _userService: UserService;
  private _auditService: AuditService;
  private _configService: ConfigService;

  private SelectableUserUnitRef: any;

  constructor(props: any) {
    super(props);

    this.activeUnitId = this.locale = "";

    this._managerService = new ManagerService();
    this._userService = new UserService();
    this._auditService = new AuditService();
    this._configService = new ConfigService();

    this.SelectableUserUnitRef = React.createRef();

    //FIXME: there are useless things in this state
    this.state = {
      curOffset: undefined,
      curUsersOffset: undefined,
      filteredTableData: [],
      haveItemSelected: false,
      iconLoading: false,
      isLoading: true,
      loadingMoreManagers: false,
      loadingMoreUsers: false,
      loadingUsersBySearch: false,
      noUserFound: false,
      savingItem: false,
      searchManager: '',
      searchUser: '',
      selectedManager: '',
      serverResponse: undefined,
      showFormModal: false,
      statusWanted: undefined,
      tableData: [],
      totalShowData: 5,
      usersAmount: 0,
      usersData: new Array<UserInterface>(),
      userSelectedAsUser: '',
      extraFields: new Array<IField>(),
      extraFieldsCheckboxesIds: new Array<string>(), //used to control which checkboxes are checked
      visibleExtraFieldsIds: new Array<string>(), //used to control which columns are visible
      isCollapsed: true,
      registerModalTableColumns: new Array<ITableColumn>(),

      showUserSelectModal: false,
      selectedIDRole: '',

      searchAvailableUsers: '',
      searchSavedUsers: '',

      loadingAvailableUsers: false,
      loadingSavedUsers: false,

      availableUsersData: [],
      savedUsersData: [],
      availableUsersAmount: 0,
      savedUsersAmount: 0,
      loadingMoreAvailableUsers: false,
      loadingMoreSavedUsers: false,
      availableUsersCurOffset: undefined,
      savedUsersCurOffset: undefined,

    }
  }

  setExtraFieldsState = async () => {
    try {
      const dataGlobal = await this._configService.getGLOBAL();
      const extraFields = dataGlobal.userFields;
      await this.setState({
        extraFields
      });

      let visibleIds: string[] = [];
      extraFields.forEach((extraField: IField) => {
        if (extraField.id && Boolean(localStorage.getItem(extraField.id)) === true) { // If true, it's visible
          visibleIds.push(extraField.id);
        }
      });

      await this.setState({
        visibleExtraFieldsIds: visibleIds,
        extraFieldsCheckboxesIds: visibleIds,
      });

    } catch (error) {
      console.error("error on fetching extra fields", error)
    }
  }

  getRegisterModalTableInitialFields = () => {
    return [
      {
        title: 'table.users.name',
        dataIndex: 'name',
        key: 'name',
        width: radioComponentTableColumnSize,
      },
      {
        title: 'table.auditors.registration',
        dataIndex: 'username',
        key: 'username',
        width: radioComponentTableColumnSize,
      },
    ] as ITableColumn[];
  }

  getVisibilityFromState = (fieldId: string): boolean => {
    return this.state.visibleExtraFieldsIds.includes(fieldId);
  }

  onCheckboxGroupChange = async (checkboxList: any) => {
    await this.setState({
      extraFieldsCheckboxesIds: checkboxList
    });

    const registerModalTableColumns: ITableColumn[] = this.state.registerModalTableColumns;

    // hides erbody
    registerModalTableColumns.filter(column => column.key !== 'name' && column.key !== "username").map(column => {
      column.isHidden = true
    });

    // FIXME: this is ugly af
    checkboxList.forEach((element: any) => {

      // now that everybody is hidden, show those who are not
      registerModalTableColumns.filter(column => column.key !== 'name' && column.key !== "username").map(column => {
        if (column.key === element) {
          column.isHidden = false;
        }
      });

    });

    await this.setState({
      registerModalTableColumns
    });
  }

  setRegisterModalTable = async () => {
    await this.setState({
      registerModalTableColumns: []
    });

    const _tableColumns = this.getRegisterModalTableInitialFields();
    let _newColumn: ITableColumn;

    if (this.state.extraFields) {
      this.state.extraFields.forEach((field: IField) => {
        if (field.id) {
          _newColumn = {
            title: String(field.name),
            dataIndex: field.id,
            key: field.id,
            isHidden: !this.getVisibilityFromState(field.id),
            width: radioComponentTableColumnSize
          }
          _tableColumns.push(_newColumn);
        }
      });
    }

    await this.setState({
      registerModalTableColumns: _tableColumns,
    });
  }

  componentDidMount() {
    this.initialData()
  }
  
  initialData = async () => {
    await this.setState({ isLoading: true });
    await this.setExtraFieldsState();
    await this.getManager(true);
    await this.setRegisterModalTable();
  }

  toggleFormModal = async () => {
    if (!this.state.showFormModal)
      await this.getUsers(true, '');

    await this.setState({
      usersData: [],
      userSelectedAsUser: '',
      haveItemSelected: false,
      searchUser: '',
      noUserFound: false,
      showFormModal: !this.state.showFormModal,
      serverResponse: undefined,
      loadingUsersBySearch: true,
      extraFieldsCheckboxesIds: this.state.visibleExtraFieldsIds
    });

    await this.setRegisterModalTable();
  };

  loadMoreManagers = async () => {
    await this.getManager(false);
  }

  getManager = async (reset: boolean) => {

    await this.setState({ showFormModal: false, loadingMoreManagers: true });
    const { tableData } = this.state;

    if (reset) {
      await this.setState({
        curOffset: undefined,
        showFormModal: false,
        isLoading: true,
      });
    }
    try {
      if (this.activeUnitId) {
        const data = await this._managerService.paging({
          unit: this.activeUnitId,
          to: undefined,
          from: undefined,
          search: this.state.searchManager,
          limit: 6,
          offset: this.state.curOffset
        });
        let newDataTableCreate: UserInterface[] = [];

        if (data !== undefined) {
          if (!reset) {
            newDataTableCreate = tableData || [];
          }
          newDataTableCreate = newDataTableCreate.concat(data.items);
        }

        await this.setState({
          tableData: newDataTableCreate,
          isLoading: false,
          iconLoading: false,
          curOffset: data.offset,
          loadingMoreManagers: false,
        });
      }
      else {
        throw new Error("No unit set");
      }
    } catch (error) {
      console.warn(error);
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
      this.setState({
        isLoading: false,
        loadingMoreManagers: false,
      });
    }
  };

  deleteManager = async (id: string) => {
    try {
      const { tableData } = this.state;
      const nextTableData = tableData.filter((item: IUser) => item.id !== id);

      await this._managerService.deleteById(id);
      await this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
    } catch (e) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.delete"), e);
      console.error(e);
    }
  };

  handleUsersSearch = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;

    await this.setState({
      loadingUsersBySearch: true,
      searchUser: SearchValue,
    })
    try {
      await this.getUsers(true, SearchValue);
    }
    catch (err) {
      console.log(err)
    }
  };

  handleUserSearchChange = async (e: any) => {
    await this.setState({
      searchUser: e.target.value,
    })
  }

  loadMoreUsers = async () => {
    await this.setState({ loadingMoreUsers: true, });
    await this.getUsers(false, this.state.searchUser);
  }

  getUsers = async (reset: boolean, user?: string) => {
    if (reset) {
      await this.setState({
        curUsersOffset: undefined
      });
    }
    try {
      if (user != undefined) {
        if (this.activeUnitId) {

          const dataTableCreate: any = []
          console.log('user service consult');
          const data = await this._userService.paging({
            unit: this.activeUnitId,
            to: undefined,
            from: undefined,
            search: user,
            isManager: false,
            disabled: false,
            limit: 6,
            offset: this.state.curUsersOffset,
          });
          console.log('user service consult response: ', data);

          data.items.map((item: any, index: number) => {
            let _tableData = {
              key: index,
              id: item.id,
              name: item.name,
              username: item.username,
              email: item.email,
              phone: item.phone,
              createdAt: item.createdAt,
              disabled: item.disabled,
              fields: item.fields
            };

            if (this.state.extraFields) {
              this.state.extraFields.map((field: any) => {
                if (item.fields) {
                  const _indexInDataFields = item.fields.findIndex((x: any) => x.label === field.id);

                  if (_indexInDataFields != -1) {
                    const _value = item.fields[_indexInDataFields].value;

                    const _extraTableData = {
                      [field.id]: _value
                    }

                    Object.assign(_tableData, _extraTableData);
                  }
                }
              });
            }

            dataTableCreate.push(_tableData);
          })

          let nextUsersData: UserInterface[] = [];

          if (!reset) {
            nextUsersData = this.state.usersData || [];
          }
          nextUsersData = nextUsersData.concat(dataTableCreate);
          await this.setState({
            usersData: nextUsersData,
            curUsersOffset: data.offset,
            noUserFound: nextUsersData.length == 0,
            loadingMoreUsers: false,
            usersAmount: data.count,
            loadingUsersBySearch: false,
          });
        }
        else {
          throw new Error("No unit set");
        }
      }
      else {
        await this.setState({
          usersData: [],
          curUsersOffset: undefined,
          loadingMoreUsers: false,
          loadingUsersBySearch: false,
          noUserFound: false,
        });
      }
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.searchUser"), error);
    }
  }

  onSubmit = async () => {
    try {
      let nextTableData: AssignmentInterface[] = [];
      await this.setState({
        isLoading: false,
        showFormModal: false,
        tableData: nextTableData,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
    }
  };

  onUserManagerFromModalSubmit = async () => {

    await this.setState({
      visibleExtraFieldsIds: this.state.extraFieldsCheckboxesIds
    });

    if (this.state.extraFields) {
      // Clears local storage just in case
      this.state.extraFields.forEach(extraField => {
        if (extraField.id) localStorage.removeItem(extraField.id);
      });
      //We persist them to the local storage to have them load back again on the next access
      this.state.visibleExtraFieldsIds.forEach((visibleExtraFieldId: string) => {
        localStorage.setItem(visibleExtraFieldId, String(true));
      });
    }

    await this.setRegisterModalTable();

    await this.setState({ savingItem: true });
    const { userSelectedAsUser, tableData } = this.state;
    try {
      const user = this.state.usersData.filter((i: UserInterface) => i.id === userSelectedAsUser)[0];

      if (user && user.id) {
        const response = await this._managerService.create(user.id);
        const nextTableData: any = tableData || [];
        nextTableData.push(response);
        await this.setState({
          showFormModal: false,
          tableData: nextTableData,
          savingItem: false,
        });

        NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.assignerSuccess"));
      }

      else {
        throw new Error("No user found")
      }
    }
    catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.select"), error);
      await this.setState({
        savingItem: false,
      });
    }
  };

  formatManagerAssignerDataToTable = (users: any) => {
    const nextData: any[] = [];

    users.map((item: IUser, index: number) => {
      let auditInfo =
        <Col key={index}>
          <div>
            <a href="#" onClick={() => this.toggleUserSelectModal(item.id || '')}>{I18n.l('table.units.linkUsers')}</a>
            {/* {item.managers === undefined || item.managers.length === 0 &&
              <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" className={"goepik-small-left-margin"} />
            } */}
          </div>
        </Col>;

      // if (item.assignment != undefined) {
      //   if (item.assignment.audits.length > 0) {
      //     auditInfo = <Col sm={24} md={12} lg={12} key={index}>
      //       <a href="#" onClick={() => this.toggleUserSelectModal(item.id || '')}>{I18n.l('table.manager.seeUsers')}</a>
      //     </Col>
      //   }
      // }

      nextData.push({
        key: item.id,
        id: item.id,
        name: item.name,
        username: item.username,
        audits: auditInfo,
      })
    });
    return nextData;
  }

  openEditModal = () => {
    this.setState({ showFormModal: true });
  };


  onRadioItemSelectionChange = async (userId: string) => {
    await this.setState({
      haveItemSelected: !!userId,
      userSelectedAsUser: userId,
    });
  }

  filterData = async () => {
    await this.setState({
      isLoading: true
    });
    try {
      await this.getManager(true);
    }
    catch (err) {
      console.log(err);
    }
  }
  searchChange = async (event: any) => {
    event.preventDefault();
    await this.setState({
      searchManager: event.target.value
    })
  };

  searchData = async (event: any) => {
    await this.setState({
      searchManager: event.target.find.value
    })
    if (event === '') {
      await this.setState({
        searchManager: ''
      })
    }
    await this.setState({
      isLoading: true,
    })
    await this.getManager(true);
  }
  //#region USER SELECT TO UNIT
  toggleUserSelectModal = async (managerID?: string) => {
    await this.setState({ selectedManager: managerID || '' })

    if (this.state.showUserSelectModal == false) {
      await this.getAvailableUsers(true, true);
      await this.getSavedUsers(true, true);
    }
    await this.setState({
      showUserSelectModal: !this.state.showUserSelectModal,
      searchAvailableUsers: '',
      searchSavedUsers: '',
    });
  }

  onRemoveUser = async (userId: string) => {
    await this.setLoadingSavedUserData(userId, true);
    const userObj = this.getUserSavedObject(userId);
    try {
      await this._managerService.userRemove(this.state.selectedManager, userId);
      await this.setLoadingSavedUserData(userId, false);

      await this.userRemoved(userId, userObj);
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userUnlikedManagerSuccess"));
    } catch (e) {
      await this.setLoadingSavedUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userRemoved = async (id: string, userRemoved: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newAvailableData: any[] = [...availableUsersData];
    newAvailableData.push(userRemoved);

    const userIndexToRemove = savedUsersData.findIndex((item: any) => item.id === id);
    let nextSavedData = [...savedUsersData];
    nextSavedData.splice(userIndexToRemove, 1);

    await this.setState({
      savedUsersData: nextSavedData,
      availableUsersData: newAvailableData,
      savedUsersAmount: (this.state.savedUsersAmount - 1),
      availableUsersAmount: (this.state.availableUsersAmount + 1)
    });
    if (this.state.savedUsersData.length == 0 && this.state.savedUsersAmount > 0) {
      await this.getPagingRemoveUsers();
    }

  }

  onAddUser = async (userId: string) => {
    const { selectedManager } = this.state
    await this.setLoadingAvailableUserData(userId, true);
    const userObj = this.getUserAvailableObject(userId);

    try {
      const response = await this._managerService.userAdd(selectedManager, userId);

      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userManagerSuccess"));
      await this.setLoadingAvailableUserData(userId, false);
      await this.userAdded(userId, userObj);

    } catch (e) {
      await this.setLoadingAvailableUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userAdded = async (id: string, userToSave: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newSaveData: any[] = [...savedUsersData];
    newSaveData.push(userToSave);

    const userIndexToRemove = availableUsersData.findIndex((item: any) => item.id === id);
    let nextAvailableData = [...availableUsersData];
    nextAvailableData.splice(userIndexToRemove, 1);

    this.SelectableUserUnitRef.current.saveAvailableUserDone();

    await this.setState({
      availableUsersData: nextAvailableData,
      savedUsersData: newSaveData,
      savedUsersAmount: (this.state.savedUsersAmount + 1),
      availableUsersAmount: (this.state.availableUsersAmount - 1)
    });
    if (this.state.availableUsersData.length == 0 && this.state.availableUsersAmount > 0) {
      await this.getPagingAddUsers();
    }
    // this.setAuditsToUser();
  }

  getUserAvailableObject(id: string) {
    const { availableUsersData } = this.state;
    let user = undefined;

    user = availableUsersData.find((item: any) => item.id === id);

    return user;
  }

  getUserSavedObject(id: string) {
    const { savedUsersData } = this.state;
    let user = undefined;

    user = savedUsersData.find((item: any) => item.id === id);

    return user;
  }

  setLoadingAvailableUserData = async (userId: string, loading: boolean) => {
    const { availableUsersData } = this.state;

    const user: any = availableUsersData.find((item) => {
      return item.id == userId;
    });
    const indexOf = availableUsersData.indexOf(user);

    const newUsersData: any[] = [...availableUsersData];
    newUsersData[indexOf].loading = loading;
    newUsersData[indexOf].disabled = loading;

    this.setState({ availableUsersData: newUsersData });
  }

  setLoadingSavedUserData = async (userId: string, loading: boolean) => {
    const { savedUsersData } = this.state;

    const user: any = savedUsersData.find((item) => {
      return item.id == userId;
    });
    const indexOf = savedUsersData.indexOf(user);

    const newUsersData: any[] = [...savedUsersData];
    newUsersData[indexOf].loading = loading;

    await this.setState({ savedUsersData: newUsersData });
  }

  onSearchAvailableUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    await this.setState({ searchAvailableUsers: SearchValue });

    await this.getAvailableUsers(true, true);
  }

  onSearchSavedUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    await this.setState({ searchSavedUsers: SearchValue });

    await this.getSavedUsers(true, true);
  }

  getPagingAddUsers = async () => {
    try {
      const data: IPagination<IUser> = await this._userService.paging({
        unit: this.activeUnitId,
        // haveManager: false,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        limit: 6,
        offset: this.state.availableUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      const loadingValue: boolean = false;

      data.items.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          username: item.username,
          loading: loadingValue,
          disabled: false,
        })
      });

      let newDataTableCreate: any[] = [];
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      await this.setState({
        availableUsersData: newDataTableCreate,
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
        availableUsersCurOffset: data.offset,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };

  getPagingRemoveUsers = async () => {
    try {
      const data: IPagination<IUser> = await this._userService.paging({
        unit: this.activeUnitId,
        // haveManager: true,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        limit: 6,
        offset: this.state.availableUsersCurOffset
      });

      let dataTableCreate: any[] = [];

      data.items.map(async (item: any) => {
        dataTableCreate.push({
          name: item.name,
          username: item.username,
          id: item.id,
          loading: false,
        })
      });

      let newDataTableCreate: any[] = [];

      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      await this.setState({
        savedUsersData: newDataTableCreate,
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
        savedUsersCurOffset: data.offset,
      });


    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };


  getAvailableUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    await this.setState({
      loadingAvailableUsers: showLoading,
      loadingMoreAvailableUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      await this.setState({
        availableUsersData: [],
        availableUsersCurOffset: undefined,
      });
    }

    try {
      const data: IPagination<IUser> = await this._userService.paging({
        unit: this.activeUnitId,
        // haveManager: false,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        limit: 10,
        offset: this.state.availableUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      const loadingValue: boolean = false;

      data.items.map((item: IUser) => {
        if (item.managers === undefined || item.managers[0] !== this.state.selectedManager) {
          if (item.id !== this.state.selectedManager) {
            dataTableCreate.push({
              id: item.id,
              name: item.name,
              username: item.username,
              loading: loadingValue,
            })
          }
        }
      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.availableUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      await this.setState({
        availableUsersData: newDataTableCreate,
        loadingAvailableUsers: false,
        availableUsersAmount: data.count,
        loadingMoreAvailableUsers: false,
        availableUsersCurOffset: data.offset,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };

  getSavedUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    await this.setState({
      loadingSavedUsers: showLoading,
      loadingMoreSavedUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      await this.setState({
        savedUsersData: [],
        savedUsersCurOffset: undefined,
      });
    }

    try {
      const data: any = await this._managerService.ListUserById(this.state.selectedManager);

      let dataTableCreate: any[] = [];

      data.forEach(async (item: any) => {
        // const idRole = item.roles.find((x: any) => x.unit === this.activeUnitId && x.role === this.state.searchManager);
        dataTableCreate.push({
          name: item.name,
          username: item.username,
          id: item.id,
          loading: false,
        })

      });
      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.savedUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      await this.setState({
        savedUsersData: newDataTableCreate,
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
      });
    }
  };

  loadMoreAvailableUsers = () => {
    this.getAvailableUsers(false, false, true);
  }

  loadMoreSavedUsers = () => {
    this.getSavedUsers(false, false, true);
  }
  //#endregion
  toggleCollapsableInstructions = () => {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  }

  render() {
    const {
      curOffset,
      haveItemSelected,
      isLoading,
      loadingMoreManagers,
      loadingMoreUsers,
      loadingUsersBySearch,
      noUserFound,
      savingItem,
      searchManager,
      searchUser,
      serverResponse,
      showFormModal,
      tableData,
      usersAmount,
      usersData,
      userSelectedAsUser,

      showUserSelectModal,
      loadingAvailableUsers,
      loadingSavedUsers,
      savedUsersData,
      availableUsersData,

      searchAvailableUsers,
      searchSavedUsers,
      availableUsersAmount,
      savedUsersAmount,
      loadingMoreAvailableUsers,
      loadingMoreSavedUsers
    } = this.state;

    if (!!isLoading) {
      return (
        <Page>
          <AppContext.Consumer>
            {({ locale, activeUnitId }) => (
              this.locale = locale,
              this.activeUnitId = activeUnitId,
              <div>
                <span>{I18n.l('common.loadingTable')}</span>
              </div>
            )}
          </AppContext.Consumer>
        </Page>
      );
    }

    let extraFieldsCheckboxesRows: JSX.Element[]; //All checkboxes
    let collapsableContent: JSX.Element; // Variable content inside the collapsable component
    if (this.state.extraFields && this.state.extraFields.length > 0) {
      extraFieldsCheckboxesRows = this.state.extraFields.map((el: any) => {
        return (
          <Col key={el.id} span={24} style={{ marginBottom: "1rem" }}>
            <Checkbox value={el.id}>{el.name}</Checkbox>
          </Col>
        )
      });

      collapsableContent = (
        <CheckboxGroup defaultValue={this.state.visibleExtraFieldsIds} onChange={this.onCheckboxGroupChange}>
          <Row>
            {extraFieldsCheckboxesRows}
          </Row>
        </CheckboxGroup>
      );
    }
    else {
      collapsableContent = (
        <p style={{ marginTop: "1rem" }} className="goepik-text-lightGray-bold">{I18n.l('assignment.tableWarning')}</p>
      )
    }


    return (
      <Page>
        <Wrapper>
          <Toolbar>
            <ToolbarItem>
              <RegisterBtnComponent
                onClick={this.toggleFormModal}
                buttonText={I18n.l('common.register') + " " + I18n.l('labels.manager')}
              />
            </ToolbarItem>
            <ToolbarItem>
              <SearchComponent
                onSubmit={this.searchData}
                placeholder='form.placeholders.managerSearch'
                defaultValue={searchManager}
                buttonText='form.buttons.search'
              />
            </ToolbarItem>
          </Toolbar>
          {/* MANAGERS TABLE */}
          {tableData.length > 0 && (
            <div className="goepik-component-tablesize">
              <Table
                columns={tableColumns}
                data={this.formatManagerAssignerDataToTable(tableData)}
                onDelete={this.deleteManager}
                noPagination={true}
                showConfirmationModal={false}
              />
              <br />
              {curOffset != undefined && curOffset != null && (
                <Button
                  className="loading-more"
                  type="primary"
                  size='large'
                  ghost
                  loading={loadingMoreManagers}
                  onClick={this.loadMoreManagers}>{I18n.l('common.seeMore')}</Button>
              )}
            </div>

          )}
          {/* WHEN THERE'S NO DATA */}
          {tableData.length === 0 && <p>{I18n.l('common.noResult')}</p>}
          {/* CHOOSE USER AS MANAGER MODAL */}
          {showFormModal && (
            <LargeModal>
              <Modal visible={showFormModal} wrapClassName={"large-modal"} footer={false} closable={false} >
                <ModalTitle>{I18n.l('form.titles.managerSelectForm')}</ModalTitle>
                <ModalContent>
                  <SearchResponsible>
                    <SearchComponent
                      onSubmit={this.handleUsersSearch}
                      placeholder='form.placeholders.alertsSearch'
                      buttonText='form.buttons.search'
                    />
                  </SearchResponsible>
                  <CollapsableComponent style={{ marginTop: '1rem' }} title={I18n.l('assignment.tableConfig')} collapsed={this.state.isCollapsed} onClick={this.toggleCollapsableInstructions}>
                    <div style={{ marginBottom: '1rem' }}>
                      <span >{I18n.l('assignment.tableInstructions')}</span>
                    </div>
                    {collapsableContent}
                  </CollapsableComponent>

                  {usersData.length > 0 && (
                    <UserRadioSelect
                      columns={this.state.registerModalTableColumns}
                      data={usersData}
                      itemSelectionChanged={(userId: string) => this.onRadioItemSelectionChange(userId)}
                      loadingMoreData={loadingMoreUsers}
                      hasMoreData={this.state.curUsersOffset != undefined && this.state.curUsersOffset != ''}
                      onShowMore={this.loadMoreUsers}
                      valueSelected={userSelectedAsUser}
                    >
                    </UserRadioSelect>
                  )}
                  {usersData.length == 0 && loadingUsersBySearch === false && noUserFound == true && searchUser.length == 0 && (
                    <p className="goepik-component-padding">{I18n.l('titles.noUserRegistered')}</p>
                  )}
                  {loadingUsersBySearch === true && (
                    <p className="goepik-component-padding">{I18n.l('common.loadingTable')}</p>
                  )}
                  {(usersData && !!noUserFound && usersData.length === 0 && searchUser.length > 0 && loadingUsersBySearch == false) && (
                    <p className="goepik-component-padding">{I18n.l('common.noResult')}</p>
                  )}
                  {searchUser.length == 0 && (
                    <p className="goepik-component-padding"></p>
                  )}

                  <p className="goepik-component-padding"></p>
                  <Row type="flex" justify="end">
                    <Button className="main-button" type="primary" ghost size="large" onClick={this.toggleFormModal}>
                      {I18n.l('common.cancel')}
                    </Button>
                    <Button className="main-button" type="primary" size="large" loading={savingItem} onClick={() => this.onUserManagerFromModalSubmit()} disabled={!haveItemSelected}>
                      {I18n.l('common.select')}
                    </Button>
                  </Row>
                </ModalContent>
              </Modal>
            </LargeModal>
          )}

          {showUserSelectModal && (
            <SelectableUnitUserComponent
              title={
                I18n.l('form.titles.linkUser')
              }
              showModal={showUserSelectModal}
              onToggleFormModal={() => this.toggleUserSelectModal()}
              serverResponse={serverResponse}
              onItemRemoved={this.onRemoveUser}
              onItemSelected={this.onAddUser}

              loadingAvailableData={loadingAvailableUsers}
              loadingSavedData={loadingSavedUsers}

              usersAvailableData={availableUsersData}
              usersSavedData={savedUsersData}
              usersAvailableTableColumns={usersAvailableTableColumns}
              usersSavedTableColums={usersSavedTableColumns}

              onSearchAvailableUsers={this.onSearchAvailableUsers}
              onSearchSavedUsers={this.onSearchSavedUsers}
              searchAvailableUsersValue={searchAvailableUsers}
              searchSavedUsersValue={searchSavedUsers}

              showMoreAvailableData={availableUsersAmount > availableUsersData.length}
              showMoreSavedData={savedUsersAmount > savedUsersData.length}
              onLoadMoreAvailableData={this.loadMoreAvailableUsers}
              onLoadMoreSavedData={this.loadMoreSavedUsers}
              loadingMoreAvailableData={loadingMoreAvailableUsers}
              loadingMoreSavedData={loadingMoreSavedUsers}

              ref={this.SelectableUserUnitRef}
            />

          )}
        </Wrapper>
      </Page >
    );
  }
}

const LargeModal = styled.div`
    .large-modal{
        width: 45%;
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .loading-more {
        margin: 15px 0;
        padding: 0;
        border: 0;
        text-align: left
    }

    .filter-group {
        margin-bottom: 50px;
    }
    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    hr{
        opacity: .6;
    }
`;
const SearchResponsible = styled.div`
    .search-component {
        max-width: 100% !important
    }
`;
const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;

  &:first-of-type {
    flex: 0;
    margin-left: 0;
  }
`;

const ModalTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
`;

const ModalContent = styled.div`
    width: 100%;
    .goepik-component-padding{
        color:#a3a3a3;
        font-weight:bold;
        font-size:14px;
    }
    .margied-elements{
        margin-left:10px;
    }
    .searchArea{
        padding-right:14px;
    }
    .searchBtn{
        border-color: #1890ff;
        color: #1890ff;
    }
    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
`;